import styled, { css } from 'styled-components';
export const Path = styled.path `
	&& {
		${({ color }) => css `
			fill: ${color ? color : 'currentColor'};
		`}
	}
`;
export const StrokePath = styled.path `
	&& {
		${({ color }) => css `
			stroke: ${color ? color : 'currentColor'};
		`}
	}
`;
